const appHeaderText = {
    eng: {
        aplicationBtn: "Get in touch",
        langBtn: "Ru"
    },
    ru: {
        aplicationBtn: "Оставить заявку",
        langBtn: "Eng"
    },

    az: {
        aplicationBtn: "Müraciət et",
        langBtn: "Az",
    }
}

export default appHeaderText